/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Amount_MismatchInputs */

const vi_einvoice_amount_mismatch = /** @type {(inputs: Einvoice_Amount_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tiền trên MISA lệch với đơn hàng`)
};

/**

* @param {Einvoice_Amount_MismatchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_amount_mismatch = /** @type {((inputs?: Einvoice_Amount_MismatchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Amount_MismatchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_amount_mismatch(inputs)
});